module.exports = __webpack_public_path__ + "img/38.0402c597.svg";